"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.detectAndStemRegularParticiple = detectAndStemRegularParticiple;

var _exceptionsParticiplesActive = require("../../researches/german/passiveVoice/exceptionsParticiplesActive");

var _exceptionsParticiplesActive2 = _interopRequireDefault(_exceptionsParticiplesActive);

var _regex = require("../../researches/german/passiveVoice/regex");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Detects whether a word is a regular participle without a prefix and if so, returns the stem.
 *
 * @param {Object}  morphologyDataVerbs The German morphology data for verbs.
 * @param {string}  word                The word (not stemmed) to check.
 *
 * @returns {string|null} The stem or null if no participle was matched.
 */


var detectAndStemParticiplesWithoutPrefixes = function detectAndStemParticiplesWithoutPrefixes(morphologyDataVerbs, word) {
  var geStemTParticipleRegex = new RegExp("^" + morphologyDataVerbs.participleStemmingClasses[1].regex);
  var geStemEtParticipleRegex = new RegExp("^" + morphologyDataVerbs.participleStemmingClasses[0].regex);
  /*
   * Check if it's a ge + stem ending in d/t + et participle.
   * As this is the more specific regex, it needs to be checked before the ge + stem + t regex.
   */

  if (geStemEtParticipleRegex.test(word)) {
    // Remove the two-letter prefix and the two-letter suffix.
    return word.slice(2, word.length - 2);
  } // Check if it's a ge + stem + t participle.


  if (geStemTParticipleRegex.test(word)) {
    // Remove the two-letter prefix and the one-letter suffix.
    return word.slice(2, word.length - 1);
  }

  return null;
};
/**
 * Determines whether a given participle pattern combined with prefixes from a given class applies to a given word
 * and if so, returns the stem.
 *
 * @param {string}      word        The word (not stemmed) to check.
 * @param {string[]}    prefixes    The prefixes of a certain prefix class.
 * @param {string}      regexPart   The regex part for a given class (completed to a full regex within the function).
 * @param {number}      startStem   Where to start cutting off the de-prefixed word.
 * @param {number}      endStem     Where to end cutting off the de-prefixed word (from the end index).
 *
 * @returns {string|null} The stem or null if no prefixed participle was matched.
 */


var detectAndStemParticiplePerPrefixClass = function detectAndStemParticiplePerPrefixClass(word, prefixes, regexPart, startStem, endStem) {
  var _iterator = _createForOfIteratorHelper(prefixes),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var currentPrefix = _step.value;
      var participleRegex = new RegExp("^" + currentPrefix + regexPart);

      if (participleRegex.test(word)) {
        var wordWithoutPrefix = word.slice(currentPrefix.length - word.length);
        var wordWithoutParticipleAffixes = wordWithoutPrefix.slice(startStem, wordWithoutPrefix.length - endStem);
        return currentPrefix + wordWithoutParticipleAffixes;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return null;
};
/**
 * Detects whether a word is a regular participle with a prefix and if so, returns the stem.
 *
 * @param {Object}  morphologyDataVerbs The German morphology data for verbs.
 * @param {string}  word                The word (not stemmed) to check.
 *
 * @returns {string|null} The stem or null if no participle with prefix was matched.
 */


var detectAndStemParticiplesWithPrefixes = function detectAndStemParticiplesWithPrefixes(morphologyDataVerbs, word) {
  var prefixesSeparableOrInseparable = morphologyDataVerbs.prefixes.separableOrInseparable;
  /*
   * It's important to preserve order here, since the ge + stem ending in d/t + et regex is more specific than
   * the ge + stem + t regex, and therefore must be checked first.
   */

  var _iterator2 = _createForOfIteratorHelper(morphologyDataVerbs.participleStemmingClasses),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var participleClass = _step2.value;
      var regex = participleClass.regex;
      var startStem = participleClass.startStem;
      var endStem = participleClass.endStem;
      var separable = participleClass.separable;
      var prefixes = separable ? morphologyDataVerbs.prefixes.separable : morphologyDataVerbs.prefixes.inseparable;
      var stem = detectAndStemParticiplePerPrefixClass(word, prefixes, regex, startStem, endStem);

      if (stem) {
        return stem;
      }

      stem = detectAndStemParticiplePerPrefixClass(word, prefixesSeparableOrInseparable, regex, startStem, endStem);

      if (stem) {
        return stem;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return null;
};
/**
 * Detects whether a word is a regular participle and if so, returns the stem.
 *
 * @param {Object}  morphologyDataVerbs The German morphology data for verbs.
 * @param {string}  word                The word (not stemmed) to check.
 *
 * @returns {string} The participle stem or null if no regular participle was matched.
 */


function detectAndStemRegularParticiple(morphologyDataVerbs, word) {
  if ((0, _regex.exceptions)(word).length > 0 || (0, _exceptionsParticiplesActive2.default)().includes(word)) {
    return "";
  }

  var stem = detectAndStemParticiplesWithoutPrefixes(morphologyDataVerbs, word);

  if (stem) {
    return stem;
  }

  stem = detectAndStemParticiplesWithPrefixes(morphologyDataVerbs, word);

  if (stem) {
    return stem;
  }

  return null;
}